var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyLink = function SvgCopyLink(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "copy_link_svg__copy_x5F_link",
    x: 0,
    y: 0,
    viewBox: "0 0 15.002 7.543",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".copy_link_svg__st0{fill:#414a5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.644 7.543H3.771a3.772 3.772 0 0 1 0-7.543h1.873a.651.651 0 0 1 0 1.3H3.771a2.47 2.47 0 0 0 0 4.939h1.873a.651.651 0 0 1 0 1.3z",
    className: "copy_link_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.013 4.422H5.019a.651.651 0 0 1 0-1.3h4.993a.651.651 0 0 1 .001 1.3",
    className: "copy_link_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.358 7.543h1.873a3.772 3.772 0 0 0 0-7.543H9.358a.651.651 0 0 0 0 1.3h1.873a2.47 2.47 0 0 1 0 4.939H9.358a.651.651 0 0 0 0 1.3z",
    className: "copy_link_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyLink);
export default ForwardRef;